import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { queryKeys } from '../constants';
import { setIsVisibleAlert, setResizable, setUpdate } from '../store';
import { dashboardV2Models } from '..';

export function useUpdateWidgets() {
  const qc = useQueryClient();
  const dispatch = useDispatch();
  const [dashboardId] = useQueryParam('dashboardId', NumberParam);
  const layout = useAppSelector(({ dashboardReducer }) => dashboardReducer.layout);

  const widgets = qc.getQueryData<{ widgets: dashboardV2Models.WidgetModel[] }>([
    queryKeys.DASHBOARD_WIDGETS,
    dashboardId
  ]);

  const newWidgets = widgets?.widgets?.map(item => {
    const findPosition = layout?.find(el => el?.i === item?.name);

    return {
      ...item,
      position: [
        findPosition?.x,
        findPosition?.y,
        findPosition?.w,
        findPosition?.h,
        findPosition?.maxW,
        findPosition?.maxH
      ] as number[]
    };
  });

  return useMutation({
    mutationFn: async () => {
      const res = await $api.put('/v1/dashboard/widget/update', newWidgets);

      return res.data;
    },
    onSuccess: async res => {
      showMessage(res.message, true);

      qc.setQueryData([queryKeys.DASHBOARD_WIDGETS, dashboardId], () => ({ widgets: newWidgets }));
    },
    onError: baseErrorHandler,
    onSettled: () => {
      dispatch(setUpdate(false));
      dispatch(setIsVisibleAlert(false));
      dispatch(setResizable({ isDragDrop: false, isResize: false }));
    }
  });
}
